import FilterQueryParams from 'src/adminPanel/entities/Filter';
import EventLocation from 'src/adminPanel/entities/office/calendar/EventLocation';
import RequestEvent from 'src/adminPanel/entities/office/calendar/RequestEvent';
import RequestEventCommissionModel from 'src/adminPanel/entities/office/calendar/RequestEventCommissionModel';
import RequestEventParticipant from 'src/adminPanel/entities/office/calendar/RequestEventParticipant';
import RequestEventType from 'src/adminPanel/entities/office/calendar/RequestEventType';
import RequestUpdateEventParticipant from 'src/adminPanel/entities/office/calendar/RequestUpdateEventParticipant';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

/* Event */
export const FETCH_EVENTS_ADMIN = 'FETCH_EVENTS_ADMIN';
export const REQUEST_EVENTS_ADMIN = 'REQUEST_EVENTS_ADMIN';
export const SUCCESS_EVENTS_ADMIN = 'SUCCESS_EVENTS_ADMIN';
export const FAILURE_EVENTS_ADMIN = 'FAILURE_EVENTS_ADMIN';

export const fetchEventsAdmin = (pageable?: PageableQueryParams, filter?: FilterQueryParams) =>
    action(FETCH_EVENTS_ADMIN, { pageable, filter });
export const requestEventsAdmin = () => action(REQUEST_EVENTS_ADMIN);
export const requestEventsAdminSuccess = (response: any) => action(SUCCESS_EVENTS_ADMIN, { response });
export const requestEventsAdminFailure = (error: any) => action(FAILURE_EVENTS_ADMIN, { error });

export const CREATE_NEW_EVENT_ADMIN = 'CREATE_NEW_EVENT_ADMIN';
export const REQUEST_CREATE_NEW_EVENT_ADMIN = 'REQUEST_CREATE_NEW_EVENT_ADMIN';
export const SUCCESS_CREATE_NEW_EVENT_ADMIN = 'SUCCESS_CREATE_NEW_EVENT_ADMIN';
export const FAILURE_CREATE_NEW_EVENT_ADMIN = 'FAILURE_CREATE_NEW_EVENT_ADMIN';

export const fetchCreateNewEventAdmin = (eventRequestDto: RequestEvent) =>
    action(CREATE_NEW_EVENT_ADMIN, { eventRequestDto });
export const requestCreateNewEventAdmin = () => action(REQUEST_CREATE_NEW_EVENT_ADMIN);
export const requestCreateNewEventAdminSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_EVENT_ADMIN, { response });
export const requestCreateNewEventAdminFailure = (error: any) => action(FAILURE_CREATE_NEW_EVENT_ADMIN, { error });

export const UPDATE_EVENT_ADMIN = 'UPDATE_EVENT_ADMIN';
export const REQUEST_UPDATE_EVENT_ADMIN = 'REQUEST_UPDATE_EVENT_ADMIN';
export const SUCCESS_UPDATE_EVENT_ADMIN = 'SUCCESS_UPDATE_EVENT_ADMIN';
export const FAILURE_UPDATE_EVENT_ADMIN = 'FAILURE_UPDATE_EVENT_ADMIN';

export const fetchUpdateEventAdmin = (eventRequestDto: RequestEvent) => action(UPDATE_EVENT_ADMIN, { eventRequestDto });
export const requestUpdateEventAdmin = () => action(REQUEST_UPDATE_EVENT_ADMIN);
export const requestUpdateEventAdminSuccess = (response: any) => action(SUCCESS_UPDATE_EVENT_ADMIN, { response });
export const requestUpdateEventAdminFailure = (error: any) => action(FAILURE_UPDATE_EVENT_ADMIN, { error });

export const DELETE_EVENT_ADMIN = 'DELETE_EVENT_ADMIN';
export const REQUEST_DELETE_EVENT_ADMIN = 'REQUEST_DELETE_EVENT_ADMIN';
export const SUCCESS_DELETE_EVENT_ADMIN = 'SUCCESS_DELETE_EVENT_ADMIN';
export const FAILURE_DELETE_EVENT_ADMIN = 'FAILURE_DELETE_EVENT_ADMIN';

export const fetchDeleteEventAdmin = (eventId: string) => action(DELETE_EVENT_ADMIN, { eventId });
export const requestDeleteEventAdmin = () => action(REQUEST_DELETE_EVENT_ADMIN);
export const requestDeleteEventAdminSuccess = (response: any) => action(SUCCESS_DELETE_EVENT_ADMIN, { response });
export const requestDeleteEventAdminFailure = (error: any) => action(FAILURE_DELETE_EVENT_ADMIN, { error });

/* Event Referent */
export const FETCH_EVENT_REFERENTS_ADMIN = 'FETCH_EVENT_REFERENTS_ADMIN';
export const REQUEST_EVENT_REFERENTS_ADMIN = 'REQUEST_EVENT_REFERENTS_ADMIN';
export const SUCCESS_EVENT_REFERENTS_ADMIN = 'SUCCESS_EVENT_REFERENTS_ADMIN';
export const FAILURE_EVENT_REFERENTS_ADMIN = 'FAILURE_EVENT_REFERENTS_ADMIN';

export const fetchEventReferentsAdmin = (pageable?: PageableQueryParams) =>
    action(FETCH_EVENT_REFERENTS_ADMIN, { pageable });
export const requestEventReferentsAdmin = () => action(REQUEST_EVENT_REFERENTS_ADMIN);
export const requestEventReferentsAdminSuccess = (response: any) => action(SUCCESS_EVENT_REFERENTS_ADMIN, { response });
export const requestEventReferentsAdminFailure = (error: any) => action(FAILURE_EVENT_REFERENTS_ADMIN, { error });

/* Event Commission Model */
export const FETCH_EVENT_COMMISSION_MODELS_ADMIN = 'FETCH_EVENT_COMMISSION_MODELS_ADMIN';
export const REQUEST_EVENT_COMMISSION_MODELS_ADMIN = 'REQUEST_EVENT_COMMISSION_MODELS_ADMIN';
export const SUCCESS_EVENT_COMMISSION_MODELS_ADMIN = 'SUCCESS_EVENT_COMMISSION_MODELS_ADMIN';
export const FAILURE_EVENT_COMMISSION_MODELS_ADMIN = 'FAILURE_EVENT_COMMISSION_MODELS_ADMIN';

export const fetchEventCommissionModelsAdmin = (pageable?: PageableQueryParams, filter?: FilterQueryParams) =>
    action(FETCH_EVENT_COMMISSION_MODELS_ADMIN, { pageable, filter });
export const requestEventCommissionModelsAdmin = () => action(REQUEST_EVENT_COMMISSION_MODELS_ADMIN);
export const requestEventCommissionModelsAdminSuccess = (response: any) =>
    action(SUCCESS_EVENT_COMMISSION_MODELS_ADMIN, { response });
export const requestEventCommissionModelsAdminFailure = (error: any) =>
    action(FAILURE_EVENT_COMMISSION_MODELS_ADMIN, { error });

export const CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN = 'CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN';
export const REQUEST_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN = 'REQUEST_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN';
export const SUCCESS_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN = 'SUCCESS_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN';
export const FAILURE_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN = 'FAILURE_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN';

export const fetchCreateNewEventCommissionModelAdmin = (commissionModel: RequestEventCommissionModel) =>
    action(CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN, { commissionModel });
export const requestCreateNewEventCommissionModelAdmin = () => action(REQUEST_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN);
export const requestCreateNewEventCommissionModelAdminSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN, { response });
export const requestCreateNewEventCommissionModelAdminFailure = (error: any) =>
    action(FAILURE_CREATE_NEW_EVENT_COMMISSION_MODEL_ADMIN, { error });

export const UPDATE_EVENT_COMMISSION_MODEL_ADMIN = 'UPDATE_EVENT_COMMISSION_MODEL_ADMIN';
export const REQUEST_UPDATE_EVENT_COMMISSION_MODEL_ADMIN = 'REQUEST_UPDATE_EVENT_COMMISSION_MODEL_ADMIN';
export const SUCCESS_UPDATE_EVENT_COMMISSION_MODEL_ADMIN = 'SUCCESS_UPDATE_EVENT_COMMISSION_MODEL_ADMIN';
export const FAILURE_UPDATE_EVENT_COMMISSION_MODEL_ADMIN = 'FAILURE_UPDATE_EVENT_COMMISSION_MODEL_ADMIN';

export const fetchUpdateEventCommissionModelAdmin = (commissionModel: RequestEventCommissionModel) =>
    action(UPDATE_EVENT_COMMISSION_MODEL_ADMIN, { commissionModel });
export const requestUpdateEventCommissionModelAdmin = () => action(REQUEST_UPDATE_EVENT_COMMISSION_MODEL_ADMIN);
export const requestUpdateEventCommissionModelAdminSuccess = (response: any) =>
    action(SUCCESS_UPDATE_EVENT_COMMISSION_MODEL_ADMIN, { response });
export const requestUpdateEventCommissionModelAdminFailure = (error: any) =>
    action(FAILURE_UPDATE_EVENT_COMMISSION_MODEL_ADMIN, { error });

export const DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN = 'DELETE_EVENT_COMMISSION_MODEL_ADMIN';
export const REQUEST_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN = 'REQUEST_DELETE_EVENT_COMMISSION_MODEL_ADMIN';
export const SUCCESS_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN = 'SUCCESS_DELETE_EVENT_COMMISSION_MODEL_ADMIN';
export const FAILURE_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN = 'FAILURE_DELETE_EVENT_COMMISSION_MODEL_ADMIN';

export const fetchDeactivateEventCommissionModelAdmin = (modelId: string) =>
    action(DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN, { modelId });
export const requestDeactivateEventCommissionModelAdmin = () => action(REQUEST_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN);
export const requestDeactivateEventCommissionModelAdminSuccess = (response: any) =>
    action(SUCCESS_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN, { response });
export const requestDeactivateEventCommissionModelAdminFailure = (error: any) =>
    action(FAILURE_DEACTIVATE_EVENT_COMMISSION_MODEL_ADMIN, { error });

/* Event Location */
export const FETCH_EVENT_LOCATIONS_ADMIN = 'FETCH_EVENT_LOCATIONS_ADMIN';
export const REQUEST_EVENT_LOCATIONS_ADMIN = 'REQUEST_EVENT_LOCATIONS_ADMIN';
export const SUCCESS_EVENT_LOCATIONS_ADMIN = 'SUCCESS_EVENT_LOCATIONS_ADMIN';
export const FAILURE_EVENT_LOCATIONS_ADMIN = 'FAILURE_EVENT_LOCATIONS_ADMIN';

export const fetchEventLocationsAdmin = (pageable?: PageableQueryParams, filter?: FilterQueryParams) =>
    action(FETCH_EVENT_LOCATIONS_ADMIN, { pageable, filter });
export const requestEventLocationsAdmin = () => action(REQUEST_EVENT_LOCATIONS_ADMIN);
export const requestEventLocationsAdminSuccess = (response: any) => action(SUCCESS_EVENT_LOCATIONS_ADMIN, { response });
export const requestEventLocationsAdminFailure = (error: any) => action(FAILURE_EVENT_LOCATIONS_ADMIN, { error });

export const CREATE_NEW_EVENT_LOCATION_ADMIN = 'CREATE_NEW_EVENT_LOCATION_ADMIN';
export const REQUEST_CREATE_NEW_EVENT_LOCATION_ADMIN = 'REQUEST_CREATE_NEW_EVENT_LOCATION_ADMIN';
export const SUCCESS_CREATE_NEW_EVENT_LOCATION_ADMIN = 'SUCCESS_CREATE_NEW_EVENT_LOCATION_ADMIN';
export const FAILURE_CREATE_NEW_EVENT_LOCATION_ADMIN = 'FAILURE_CREATE_NEW_EVENT_LOCATION_ADMIN';

export const fetchCreateNewEventLocationAdmin = (eventLocation: EventLocation) =>
    action(CREATE_NEW_EVENT_LOCATION_ADMIN, { eventLocation });
export const requestCreateNewEventLocationAdmin = () => action(REQUEST_CREATE_NEW_EVENT_LOCATION_ADMIN);
export const requestCreateNewEventLocationAdminSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_EVENT_LOCATION_ADMIN, { response });
export const requestCreateNewEventLocationAdminFailure = (error: any) =>
    action(FAILURE_CREATE_NEW_EVENT_LOCATION_ADMIN, { error });

export const UPDATE_EVENT_LOCATION_ADMIN = 'UPDATE_EVENT_LOCATION_ADMIN';
export const REQUEST_UPDATE_EVENT_LOCATION_ADMIN = 'REQUEST_UPDATE_EVENT_LOCATION_ADMIN';
export const SUCCESS_UPDATE_EVENT_LOCATION_ADMIN = 'SUCCESS_UPDATE_EVENT_LOCATION_ADMIN';
export const FAILURE_UPDATE_EVENT_LOCATION_ADMIN = 'FAILURE_UPDATE_EVENT_LOCATION_ADMIN';

export const fetchUpdateEventLocationAdmin = (eventLocation: EventLocation) =>
    action(UPDATE_EVENT_LOCATION_ADMIN, { eventLocation });
export const requestUpdateEventLocationAdmin = () => action(REQUEST_UPDATE_EVENT_LOCATION_ADMIN);
export const requestUpdateEventLocationAdminSuccess = (response: any) =>
    action(SUCCESS_UPDATE_EVENT_LOCATION_ADMIN, { response });
export const requestUpdateEventLocationAdminFailure = (error: any) =>
    action(FAILURE_UPDATE_EVENT_LOCATION_ADMIN, { error });

export const DEACTIVATE_EVENT_LOCATION_ADMIN = 'DEACTIVATE_EVENT_LOCATION_ADMIN';
export const REQUEST_DEACTIVATE_EVENT_LOCATION_ADMIN = 'REQUEST_DEACTIVATE_EVENT_LOCATION_ADMIN';
export const SUCCESS_DEACTIVATE_EVENT_LOCATION_ADMIN = 'SUCCESS_DEACTIVATE_EVENT_LOCATION_ADMIN';
export const FAILURE_DEACTIVATE_EVENT_LOCATION_ADMIN = 'FAILURE_DEACTIVATE_EVENT_LOCATION_ADMIN';

export const fetchDeactivateEventLocationAdmin = (modelId: string) =>
    action(DEACTIVATE_EVENT_LOCATION_ADMIN, { modelId });
export const requestDeactivateEventLocationAdmin = () => action(REQUEST_DEACTIVATE_EVENT_LOCATION_ADMIN);
export const requestDeactivateEventLocationAdminSuccess = (response: any) =>
    action(SUCCESS_DEACTIVATE_EVENT_LOCATION_ADMIN, { response });
export const requestDeactivateEventLocationAdminFailure = (error: any) =>
    action(FAILURE_DEACTIVATE_EVENT_LOCATION_ADMIN, { error });

/* Event LanguageCountry */
export const FETCH_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN = 'FETCH_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN';
export const REQUEST_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN = 'REQUEST_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN';
export const SUCCESS_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN = 'SUCCESS_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN';
export const FAILURE_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN = 'FAILURE_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN';

export const fetchEventLanguageCountryModelsAdmin = (pageable?: PageableQueryParams, filter?: FilterQueryParams) =>
    action(FETCH_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN, { pageable, filter });
export const requestEventLanguageCountryModelsAdmin = () => action(REQUEST_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN);
export const requestEventLanguageCountryModelsAdminSuccess = (response: any) =>
    action(SUCCESS_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN, { response });
export const requestEventLanguageCountryModelsAdminFailure = (error: any) =>
    action(FAILURE_EVENT_LANGUAGE_COUNTRY_MODELS_ADMIN, { error });

export const DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN = 'DELETE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN';
export const REQUEST_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN =
    'REQUEST_DELETE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN';
export const SUCCESS_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN =
    'SUCCESS_DELETE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN';
export const FAILURE_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN =
    'FAILURE_DELETE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN';

export const fetchDeleteEventLanguageCountryModelAdmin = (modelId: string) =>
    action(DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN, { modelId });
export const requestDeleteEventLanguageCountryModelAdmin = () =>
    action(REQUEST_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN);
export const requestDeleteEventLanguageCountryModelAdminSuccess = (response: any) =>
    action(SUCCESS_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN, { response });
export const requestDeleteEventLanguageCountryModelAdminFailure = (error: any) =>
    action(FAILURE_DEACTIVATE_EVENT_LANGUAGE_COUNTRY_MODEL_ADMIN, { error });

/* Event Type */
export const FETCH_EVENT_TYPES_ADMIN = 'FETCH_EVENT_TYPES_ADMIN';
export const REQUEST_EVENT_TYPES_ADMIN = 'REQUEST_EVENT_TYPES_ADMIN';
export const SUCCESS_EVENT_TYPES_ADMIN = 'SUCCESS_EVENT_TYPES_ADMIN';
export const FAILURE_EVENT_TYPES_ADMIN = 'FAILURE_EVENT_TYPES_ADMIN';

export const fetchEventTypesAdmin = (pageable?: PageableQueryParams, filter?: FilterQueryParams) =>
    action(FETCH_EVENT_TYPES_ADMIN, { pageable, filter });
export const requestEventTypesAdmin = () => action(REQUEST_EVENT_TYPES_ADMIN);
export const requestEventTypesAdminSuccess = (response: any) => action(SUCCESS_EVENT_TYPES_ADMIN, { response });
export const requestEventTypesAdminFailure = (error: any) => action(FAILURE_EVENT_TYPES_ADMIN, { error });

export const CREATE_NEW_EVENT_TYPE_ADMIN = 'CREATE_NEW_EVENT_TYPE_ADMIN';
export const REQUEST_CREATE_NEW_EVENT_TYPE_ADMIN = 'REQUEST_CREATE_NEW_EVENT_TYPE_ADMIN';
export const SUCCESS_CREATE_NEW_EVENT_TYPE_ADMIN = 'SUCCESS_CREATE_NEW_EVENT_TYPE_ADMIN';
export const FAILURE_CREATE_NEW_EVENT_TYPE_ADMIN = 'FAILURE_CREATE_NEW_EVENT_TYPE_ADMIN';

export const fetchCreateNewEventTypeAdmin = (eventTypeRequest: RequestEventType) =>
    action(CREATE_NEW_EVENT_TYPE_ADMIN, { eventTypeRequest });
export const requestCreateNewEventTypeAdmin = () => action(REQUEST_CREATE_NEW_EVENT_TYPE_ADMIN);
export const requestCreateNewEventTypeAdminSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_EVENT_TYPE_ADMIN, { response });
export const requestCreateNewEventTypeAdminFailure = (error: any) =>
    action(FAILURE_CREATE_NEW_EVENT_TYPE_ADMIN, { error });

export const UPDATE_EVENT_TYPE_ADMIN = 'UPDATE_EVENT_TYPE_ADMIN';
export const REQUEST_UPDATE_EVENT_TYPE_ADMIN = 'REQUEST_UPDATE_EVENT__TYPE_ADMIN';
export const SUCCESS_UPDATE_EVENT_TYPE_ADMIN = 'SUCCESS_UPDATE_EVENT__TYPE_ADMIN';
export const FAILURE_UPDATE_EVENT_TYPE_ADMIN = 'FAILURE_UPDATE_EVENT__TYPE_ADMIN';

export const fetchUpdateEventTypeAdmin = (eventTypeRequest: RequestEventType) =>
    action(UPDATE_EVENT_TYPE_ADMIN, { eventTypeRequest });
export const requestUpdateEventTypeAdmin = () => action(REQUEST_UPDATE_EVENT_TYPE_ADMIN);
export const requestUpdateEventTypeAdminSuccess = (response: any) =>
    action(SUCCESS_UPDATE_EVENT_TYPE_ADMIN, { response });
export const requestUpdateEventTypeAdminFailure = (error: any) => action(FAILURE_UPDATE_EVENT_TYPE_ADMIN, { error });

export const DEACTIVATE_EVENT_TYPE_ADMIN = 'DEACTIVATE_EVENT_TYPE_ADMIN';
export const REQUEST_DEACTIVATE_EVENT_TYPE_ADMIN = 'REQUEST_DEACTIVATE_EVENT_TYPE_ADMIN';
export const SUCCESS_DEACTIVATE_EVENT_TYPE_ADMIN = 'SUCCESS_DEACTIVATE_EVENT_TYPE_ADMIN';
export const FAILURE_DEACTIVATE_EVENT_TYPE_ADMIN = 'FAILURE_DEACTIVATE_EVENT_TYPE_ADMIN';

export const fetchDeactivateEventTypeAdmin = (eventTypeId: string) =>
    action(DEACTIVATE_EVENT_TYPE_ADMIN, { eventTypeId });
export const requestDeactivateEventTypeAdmin = () => action(REQUEST_DEACTIVATE_EVENT_TYPE_ADMIN);
export const requestDeactivateEventTypeAdminSuccess = (response: any) =>
    action(SUCCESS_DEACTIVATE_EVENT_TYPE_ADMIN, { response });
export const requestDeactivateEventTypeAdminFailure = (error: any) =>
    action(FAILURE_DEACTIVATE_EVENT_TYPE_ADMIN, { error });

/* Event Participant */
export const FETCH_EVENT_PARTICIPANTS = 'FETCH_EVENT_PARTICIPANTS';
export const REQUEST_EVENT_PARTICIPANTS_ADMIN = 'REQUEST_EVENT_PARTICIPANTS_ADMIN';
export const SUCCESS_EVENT_PARTICIPANTS_ADMIN = 'SUCCESS_EVENT_PARTICIPANTS_ADMIN';
export const FAILURE_EVENT_PARTICIPANTS_ADMIN = 'FAILURE_EVENT_PARTICIPANTS_ADMIN';

export const fetchEventParticipantsAdmin = (eventId: string, pageable?: PageableQueryParams) =>
    action(FETCH_EVENT_PARTICIPANTS, { pageable, eventId });
export const requestEventParticipantsAdmin = () => action(REQUEST_EVENT_PARTICIPANTS_ADMIN);
export const requestEventParticipantsAdminSuccess = (response: any) =>
    action(SUCCESS_EVENT_PARTICIPANTS_ADMIN, { response });
export const requestEventParticipantsAdminFailure = (error: any) => action(FAILURE_EVENT_PARTICIPANTS_ADMIN, { error });

export const CREATE_NEW_EVENT_PARTICIPANT_ADMIN = 'CREATE_NEW_EVENT_PARTICIPANT_ADMIN';
export const REQUEST_CREATE_NEW_EVENT_PARTICIPANT_ADMIN = 'REQUEST_CREATE_NEW_EVENT_PARTICIPANT_ADMIN';
export const SUCCESS_CREATE_NEW_EVENT_PARTICIPANT_ADMIN = 'SUCCESS_CREATE_NEW_EVENT_PARTICIPANT_ADMIN';
export const FAILURE_CREATE_NEW_EVENT_PARTICIPANT_ADMIN = 'FAILURE_CREATE_NEW_EVENT_PARTICIPANT_ADMIN';

export const fetchCreateNewEventParticipantAdmin = (eventParticipantRequest: RequestEventParticipant) =>
    action(CREATE_NEW_EVENT_PARTICIPANT_ADMIN, { eventParticipantRequest });
export const requestCreateNewEventParticipantAdmin = () => action(REQUEST_CREATE_NEW_EVENT_PARTICIPANT_ADMIN);
export const requestCreateNewEventParticipantAdminSuccess = (response: any) =>
    action(SUCCESS_CREATE_NEW_EVENT_PARTICIPANT_ADMIN, { response });
export const requestCreateNewEventParticipantAdminFailure = (error: any) =>
    action(FAILURE_CREATE_NEW_EVENT_PARTICIPANT_ADMIN, { error });

export const UPDATE_EVENT_PARTICIPANT_ADMIN = 'UPDATE_EVENT_PARTICIPANT_ADMIN';
export const REQUEST_UPDATE_EVENT_PARTICIPANT_ADMIN = 'REQUEST_UPDATE_EVENT_PARTICIPANT_ADMIN';
export const SUCCESS_UPDATE_EVENT_PARTICIPANT_ADMIN = 'SUCCESS_UPDATE_EVENT_PARTICIPANT_ADMIN';
export const FAILURE_UPDATE_EVENT_PARTICIPANT_ADMIN = 'FAILURE_UPDATE_EVENT_PARTICIPANT_ADMIN';

export const fetchUpdateEventParticipantAdmin = (udpateEventParticipantRequest: RequestUpdateEventParticipant) =>
    action(UPDATE_EVENT_PARTICIPANT_ADMIN, { udpateEventParticipantRequest });
export const requestUpdateEventParticipantAdmin = () => action(REQUEST_UPDATE_EVENT_PARTICIPANT_ADMIN);
export const requestUpdateEventParticipantAdminSuccess = (response: any) =>
    action(SUCCESS_UPDATE_EVENT_PARTICIPANT_ADMIN, { response });
export const requestUpdateEventParticipantAdminFailure = (error: any) =>
    action(FAILURE_UPDATE_EVENT_PARTICIPANT_ADMIN, { error });

export const DELETE_EVENT_PARTICIPANT_ADMIN = 'DELETE_EVENT_PARTICIPANT_ADMIN';
export const REQUEST_DELETE_EVENT_PARTICIPANT_ADMIN = 'REQUEST_DELETE_EVENT_PARTICIPANT_ADMIN';
export const SUCCESS_DELETE_EVENT_PARTICIPANT_ADMIN = 'SUCCESS_DELETE_EVENT_PARTICIPANT_ADMIN';
export const FAILURE_DELETE_EVENT_PARTICIPANT_ADMIN = 'FAILURE_DELETE_EVENT_PARTICIPANT_ADMIN';

export const fetchDeleteEventParticipantAdmin = (eventParticipantId: string) =>
    action(DELETE_EVENT_PARTICIPANT_ADMIN, { eventParticipantId });
export const requestDeleteEventParticipantAdmin = () => action(REQUEST_DELETE_EVENT_PARTICIPANT_ADMIN);
export const requestDeleteEventParticipantAdminSuccess = (response: any) =>
    action(SUCCESS_DELETE_EVENT_PARTICIPANT_ADMIN, { response });
export const requestDeleteEventParticipantAdminFailure = (error: any) =>
    action(FAILURE_DELETE_EVENT_PARTICIPANT_ADMIN, { error });
